import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { MaterialModule, AteneaModule } from "@atenea-cms";

import { DashboardRoutes } from "./dashboard.routes";
import { DashboardScreenComponent } from "./dashboard-screen/dashboard-screen.component";
import { DashboardService } from "./shared/dashboard.service";

@NgModule({
  imports: [BrowserModule, DashboardRoutes, MaterialModule, AteneaModule],
  declarations: [DashboardScreenComponent],
  providers: [DashboardService],
})
export class DashboardModule {}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/dashboard/dashboard.module.ts